
<div class="modal-header">{{job.name}}</div>
<form class="modal-body" #form="ngForm">
  <job-variables-input [job]="job" [vars]="vars" (enter)="form.form.valid &amp;&amp; start()"></job-variables-input>
</form>
<div class="modal-footer">
  <button class="btn btn-outline-primary" [clickBlocking]="start" [disabled]="!form.form.valid"><i class="far fa-play"></i><span translate>Start</span></button>
  <button class="btn btn-outline-secondary" (click)="cancel()" translate>Close</button>
</div>